<template>
  <div class="self_element_style_qja_a_this" id="masterFundRoot">
    <basic-container>
      <div class="form_wrapper">
        <div class="form_header">
          <div class="form_header_name">
            {{ title }}
          </div>
          <!-- <div class="form_header_remarks">
            带 <span class="red_color">* </span>为必填项
          </div> -->
          <div class="form_header_remarks">
            带<span class="red_color">* </span>为必填项
          </div>
        </div>
        <!-- {{ provinceName }} -->
        <div class="form_content">
          <avue-form
            :option="option"
            ref="form"
            v-model="form"
          >
            <template #managerName>
              <el-input 
                v-if="$router.params && $router.params.id"
                v-model="form.managerName"
                :disabled="true"
              ></el-input>
              <div class="add-fund-manager" v-else>
                <CommonSelect
                  bindLabel="name"
                  bindKey="id"
                  bindValue="name"
                  dataUrl="fund/manager/page"
                  methods="get"
                  dataMethod="params"
                  searchKey="name"
                  :bindId="managerId ? managerId : ''"
                  @handleChange="setManagerInfo"
                />
                <!-- <div
                  class="add-button el-icon-plus"
                  @click="dialogShow = true"
                >添加</div> -->
              </div>
              
            </template>

            <template slot="group1Header">
              <div class=""></div>
            </template>

            <template slot="regions">
              <el-cascader
                :props="props"
                :key="modakay"
                @change="changeCascader"
                emitPayh="true"
                :value="form.regions"
              ></el-cascader>
            </template>
            <template slot="group2Header">
              <div class="label_name">基金管理人</div>
            </template>
            <!-- <template slot="menuForm">
              <el-button
                type="primary"
                icon="el-icon-check"
                size="small"
                :loading="loading"
                @click="btnSave"
              >保存</el-button>
            </template> -->
          </avue-form>

          <!-- <template v-for="(item, index) in buttonConfig">
            <Accessory
              :ref="item.id"
              :fileTitle="item.name"
              :key="`${item.id}-${index}`"
              :id="item.id"
              :idname="item.name"
              :upload="true"
              :projectid="data.id"
              :fileMenuUrlname="`基金附件-${item.name}`"
            />
          </template>           -->
        </div>
      </div>

      <Accessory
        fileTitle="设立文件"
        idname="设立文件"
        :upload="true"
        :projectid="id"
        :fileMenuUrlname="`基金业务-出资主体`"
      />
      <div class="bottom-container">
        <div class="button-container">
          <!-- <el-button type="primary" plain @click="btnSave(true)">发起审核</el-button> -->
          <el-button type="primary" @click="btnSave(false)">保存</el-button>
        </div>
      </div>
    </basic-container>

    <!-- 电梯 -->
    <!-- <NavigatorBar
      :buttonConfig="buttonConfig"
      rootId="masterFundRoot"
    /> -->

    <el-dialog
      :close-on-click-modal="false"
      title="添加基金管理人"
      :visible.sync="dialogShow"
      width="30%"
      :before-close="handleClose"
    >
      <div class="add-person-form-container">
        <avue-form
          ref="addPersonForm"
          v-model="personFormData"
          :option="addPersonFormConfig"
        >
            <template slot="region">
                <el-cascader
                  :options="regionOptions"
                  emitPayh="true"
                  :value="selectedAddress"
                  @change="changeCascaders"
                >
                </el-cascader>
            </template>        
        </avue-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="dialogShow = false"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="addPersonForm"
        >确 定</el-button>
      </span>
    </el-dialog>    
  </div>
</template>

<script>
import { queryVirtualId } from "@/api/fund/angelFund"
import * as api from "@/api/fund/masterfund";
import { mapGetters } from "vuex";
import * as Verification from "@/util/validate";
import SelectPerson from "@/components/SelectPersonnel/person";
import CommonSelect from "@/components/commonSelect/commonSelect";
import { addFundManger } from "@/api/fund/fundApprove"
import NavigatorBar from "@/components/navigatorBar/navigatorBar";
import Accessory from "@/components/accessoriesother/accessory";
import { regionData, TextToCode, CodeToText } from "element-china-area-data";
import util from "@/mixins/util"
import { addManagerFormConfig } from "@/views/fund/fundManager/config.js";

export default {
  name: "thirdRegister",
  mixins: [ util ],
  data() {
    return {
      id: '',
      managerId: '',
      regionOptions: regionData,
      dialogShow: false,
      form: {
           regions: ["浙江省", "台州市", "椒江区"],

      },
      addPersonFormConfig: addManagerFormConfig(),
      modakay: 0,
      regions: ["浙江省", "台州市", "椒江区"],
      props: {
        lazy: true,
        label: "name",
        value: "name",
        lazyLoad(node, resolve) {
          let level = node.level;
          let data = node.data || {};
          let code = data.id;
          let list = [];
          let callback = () => {
            resolve(
              (list || []).map((ele) => {
                return Object.assign(ele, {
                  leaf: level >= 2,
                });
              })
            );
          };
          api
            .district({
              level: level,
              pid: code,
            })
            .then((res) => {
              list = res.data.data;
              callback();
            });
        },
      },

      option: {
        labelWidth: 180,
        emptyBtn: false,
        submitBtn: false,
        group: [
          {
            icon: "el-icon-info",
            label: "分组1",
            prop: "group1",
            column: [
              {
                label: "出资主体",
                prop: "name",
                rules: [
                  {
                    required: true,
                    message: "请输入出资主体",
                    trigger: "blur",
                  },
                  // { validator: Verification.validatePass2, trigger: "blur" }
                ],
              },
              {
                label: "设立时间",
                prop: "establishmentTime",
                type: "date",
                clearable: false,
                rules: [
                  {
                    required: true,
                    message: "请选择设立时间",
                    trigger: "blur",
                  },
                ],
                format: "yyyy-MM-dd",
                valueFormat: "yyyy-MM-dd",
              },
              {
                label: "注册资本",
                prop: "peScale",
                prepend: "￥",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入"
                  if(this.form.govIndustrySubscribed && this.form.govIndustrySubscribed != ''){
                    // let calcNum = ((this.form.govIndustrySubscribed / value)*100)
                    // this.form.capitalRatio = Math.ceil((Math.pow(10,2)*calcNum))/Math.pow(10,2)
                    this.form.capitalRatio = ((this.form.govIndustrySubscribed / value)*100).toFixed(2)
                    this.form.otherCapitalSubscribed = value - this.form.govIndustrySubscribed
                  }
                },
                rules: [
                  {
                    required: true,
                    message: "请输入注册资本",
                    trigger: "blur",
                  },
                  { validator: Verification.checkNumber, trigger: "blur" },

                ],
              },
              {
                label: "基金实缴金额",
                prop: "totalCapitalPaid",
                prepend: "￥",
                  tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                rules: [
                  {
                    required: true,
                    message: "请输入基金实缴金额",
                    trigger: "blur",
                  },
                  { validator: Verification.checkNumber, trigger: "blur" },
                ],
              },
              {
                label: "直投规模",
                prop: "directInvestScale",
                prepend: "￥",
                tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入"
                  // if(this.form.peScale && this.form.peScale != ''){
                  //   this.form.capitalRatio = ((value / this.form.peScale)*100).toFixed(2)
                  //   this.form.otherCapitalSubscribed = this.form.peScale - value
                  // }
                },
                rules: [
                  {
                    required: true,
                    message: "请输入直投规模",
                    trigger: "blur",
                  },
                  { validator: Verification.checkNumber, trigger: "blur" },
                ],
              },
              {
                label: "合作基金认缴",
                prop: "cooperationFundSubscribed",
                prepend: "￥",
                  tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                rules: [
                  {
                    required: true,
                    message: "请输入合作基金认缴",
                    trigger: "blur",
                  },
                  { validator: Verification.checkNumber, trigger: "blur" },
                ],
              },
              {
                label: "实缴规模",
                prop: "cooperationFundPaid",
                prepend: "￥",
                tip: "",
                // disabled: true,
                placeholder: "请输入实缴规模",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "";
                },
                rules: [
                  {
                    required: true,
                    message: "请输入实缴规模",
                    trigger: "blur",
                  },
                  { validator: Verification.checkNumber, trigger: "blur" },
                ],
              },
              {
                label: "合作基金已投金额",
                prop: "cooperationFundInvested",
                prepend: "￥",
                tip: "",
                // disabled: true,
                placeholder: "请输入合作基金已投金额",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "";
                },
                rules: [
                  {
                    required: true,
                    message: "请输入合作基金已投金额",
                    trigger: "blur",
                  },
                  { validator: Verification.checkNumber, trigger: "blur" },
                ],
              },              
              {
                label: "金投方出资比例",
                prop: "capitalRatio",
                append: "%",
                // disabled: true,
                rules: [
                  {
                    required: true,
                    message: "请输入金投放出资比例",
                    trigger: "blur",
                  },
                  { validator: Verification.checkNumber, trigger: "blur" },
                ],
              }, {
                label: "基金管理人",
                prop: "managerName",
                formslot: true,
                placeholder: "请输入基金管理人",
                rules: [
                  {
                    required: true,
                    message: "请输入基金管理人",
                    trigger: "blur",
                  },
                ],
              },
              {
                label: "其他合伙人实缴额",
                prepend: "￥",
                  tip: "",
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                prop: "otherCapitalPaid",
              },
              {
                label: "其他合伙人认缴额",
                prepend: "￥",
                tip: "",
                // disabled: true,
                tipPlacement: "top-start",
                change: ({ value, column }) => {
                  column.tip = value
                    ? this.changeNumMoneyToChinese(value)
                    : "请输入";
                },
                prop: "otherCapitalSubscribed",
              },            
              {
                label: "投后报告周期",
                prop: "manageCycle",
                slot: true,
                type: "select",
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=reportcycle_managecycle",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
                dataType: "number",
              }
            ],
          },
        ],
      },

      personFormData: {},
      checkUserList: [],
      buttonConfig:[
        {
          id: 'el1',
          name: '设立文件'
        },        {
          id: 'el2',
          name: '中介采购'
        },        {
          id: 'el3',
          name: '尽职调查'
        },        {
          id: 'el4',
          name: '投资建议书'
        },        {
          id: 'el5',
          name: '项目方案'
        },        {
          id: 'el6',
          name: '投资决策'
        },        {
          id: 'el7',
          name: '投资协议'
        },        {
          id: 'el8',
          name: '投放审核'
        },
      ],      
    };
  },

  components: {
    Accessory,
    NavigatorBar,
    SelectPerson,
    CommonSelect
  },
  computed: {
    ...mapGetters(["userInfo"]),
    title() {
      return this.$route.params.id === "-1" ? "新增出资主体" : "编辑出资主体";
    },
  },
  watch: {},
  async created() {
    if (this.$route.params.id != -1) {
      this.onLoad(this.$route.params.id);
      this.id = this.$route.params.id;
    }else {
      this.id = await this.getVirtualID()
    }

    this.form.managerUsername = this.userInfo.nick_name;
    // console.log(this.userInfo.user_id);
    // this.checkUserList.push(this.userInfo.user_id)

    // this.getInfo();
  },
  methods: {
    setManagerInfo(data) {
      this.form.managerName = data.name
      this.form.managerId = data.id
    },

    async addPersonForm() {
      let res = await addFundManger(this.personFormData)
      if(res.data.code == 200) {
        this.form.managerName = this.personFormData.name
        this.form.managerId = res.data.data.id
        this.managerId = res.data.data.id
        this.dialogShow = false
        this.$message({
          type: "success",
          message: "新增管理员成功",
        })
      }
    },
    
    changeCascaders(value) {
      let addressArray = []
      if (value.length > 0) {
        value.map((item) => {
          addressArray.push(CodeToText[item]);
        });

        this.personFormData.region = addressArray.join(",");
      }
    },

    changeCascader(value) {
      this.form.regions = value;
      // console.log(value);
      // console.log("ssss");
    },
    onLoad(id) {
      api
        .detail({ id: id })
        .then((res) => {
          this.managerId = res.data.data.managerId
          this.form = res.data.data;
          this.form.regions =
            res.data.data.manager.region == ""
              ? this.regions
              : res.data.data.manager.region.split("/");
          if (res.data.data.capitalRatio == -1) {
            this.form.capitalRatio = "";
          }
          if (res.data.data.peScale == -1) {
            this.form.peScale = "";
          }
             if (res.data.data.allFundAmount == -1) {
            this.form.allFundAmount = "";
          }
             if (res.data.data.totalCapitalPaid == -1) {
            this.form.totalCapitalPaid = "";
          }
             if (res.data.data.govIndustryPaid == -1) {
            this.form.govIndustryPaid = "";
          }
             if (res.data.data.otherCapitalPaid == -1) {
            this.form.otherCapitalPaid = "";
          }
            if (res.data.data.otherCapitalSubscribed == -1) {
            this.form.otherCapitalSubscribed = "";
          }
            if (res.data.data.manageCycle == -1) {
            this.form.manageCycle = "";
          }

          // provinceName = res.data.data.provinceName;

          this.$nextTick(() => {
            this.provinceName = res.data.data.provinceName;
            this.modakay++;
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },

    btnSave(audit) {
      let self = this
      this.$refs['form'].validate((valid1,done1) => {
        if(valid1){
          self.saveData(audit)
          done1()
        }
      })
    },

    saveData(audit) {
      // if (this.form.bankName == "") {
      //   this.$message({
      //     type: "error",
      //     message: "请填写银行名称 ",
      //   });
      //   return;
      // }
      let msg = this.$route.params.id != -1?'修改数据成功': '新增数据成功'
      let data = {
        id: this.id,
        bizType: '3',
        ...this.form,
      };
      // data.manager.establishmentTime = this.form.mestablishmentTime;
      // data.manager.region = this.form.regions.join("/");
      api
        .submit(data)
        .then((res) => {
          // console.log(res.data);
          // this.$router.push({
          //   path: "/zd/bankmanage/bankmanageDetail/",
          //   query: { id: res.data.data }
          // });
          this.$message.success(msg)
          if(audit) {
            // 发起审核
            this.updatastate()
          }else {
            this.$router.push({
              path: `/otherFund/investMainBody/detail/${res.data.data}`,
            });
          }

        })
        .catch((res) => {
          console.log(res);
        });
    },

    getVirtualID() {
      return new Promise((resolve, reject) => {
        queryVirtualId().then(res => {
          resolve(res.data.data);
        }).catch(err => {
          reject(err);
        });
      })
    },    

    updatastate() {
      api.submitaudit(this.id)
        .then((res) => {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.$router.push({
            path: `/otherFund/investMainBody/detail/${this.id}`,
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },    
    //提交
    handleSubmit() {
      console.log(this.form);

      // this.vaildData(obj2),false
      // return;
      this.$refs.form.validate((vaild) => {
        if (vaild) {
          api
            .submit(data)
            .then((res) => {
              console.log(res.data);
              this.$router.push({
                path: "/fund/masterfund/masterfundDetail/",
                query: { id: res.data.data },
              });
            })
            .catch((res) => {
              console.log(res);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom-container{
  width: 100%;
  height: 70px;
  position: fixed;
  // z-index: 1000;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
  .button-container{
    width: 93%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.form_wrapper {
  height: 100%;
  // margin: 0 15%;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;
  margin-bottom: 50px;
  .add-fund-manager{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .add-button{
      cursor: pointer;
      width: 70px;
      margin-left: 15px;
      text-align: right;
      color: #409eff;
    }
  }
  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 14px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
    margin-bottom: 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
.btn_save {
  text-align: center;
}
/deep/ .el-dialog__header {
  border-radius: 5px 5px 0px 0px;
  // background-color: rgb(245, 245, 245);
  color: #333;
}
/deep/ .el-dialog__body {
    padding: 30px 20px 0 20px !important;
  }
</style>

<style>
.self_element_style_qja_a_this .el-card.is-always-shadow {
  background-color: #f0f2f5;
}
.self_element_style_qja_a_this .el-button {
  width: 140px;
}
.self_element_style_qja_a_this .avue-group {
  pointer-events: none;
}
.self_element_style_qja_a_this .el-collapse-item__wrap {
  pointer-events: all;
}
.self_element_style_qja_a_this .avue-group__header {
  border-bottom: none;
}
.self_element_style_qja_a_this .avue-group .el-collapse-item__arrow {
  display: none;
}

</style>
